// selectors

export const getNutritionistInfo = state => {
  return state.Nutritionist.nutritionist;
};
